export default __webpack_public_path__ + "static/media/bn.8c0b8972.svg";